<template>
<div>
<!-- Modal -->
<div class="modal " id="MarketPromoModal" data-backdrop="static" data-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header bg-success text-white">
        
        <h4 class="modal-title" id="staticBackdropLabel">
          <i style="color: yellow;" class="fas fa-edit mr-2" aria-hidden="true"></i>
          
          REGISTRAZIONE PROMO</h4>
        
      </div>
<form v-on:submit.prevent="submit()">
      <div class="modal-body">
        <alert-box class="mt-1 mb-1"  @close="msg.title=''" v-bind:msg="msg"  ></alert-box>    

  <div class="form-row align-items-center">
    <div class="col-auto">
      
      <div class="input-group ">
        <div class="input-group-prepend">
          <div class="input-group-text"><strong>% Sconto 1</strong></div>
        </div>
        
        <input required id="discount1" type="number" class="form-control "  placeholder="Sconto 1" v-model="discount1">
      </div>
      
    </div>
    <div class="col-auto">
      
      <div class="input-group ">
        <div class="input-group-prepend">
          <div class="input-group-text"><strong>% Sconto 2</strong></div>
        </div>
        <input required type="number" class="form-control"  placeholder="Sconto 2" v-model="discount2">
      </div>
    </div>

    <div class="col-auto">

      <button :disabled="bt_spinner" type="submit" class="btn btn-primary ">
        <i style="color:yellow" class="fas fa-check mr-2" aria-hidden="true"></i>
        APPLICA
        <span v-if="bt_spinner"  class="spinner-border spinner-border-sm ml-3" role="status" aria-hidden="true"></span>
      </button>
    </div>
   

  </div>
     
</div>

<div class="modal-footer">
  <button @click="$emit('close')" type="button" class="btn btn-secondary mr-3" data-dismiss="modal">CHIUDI</button>
  
</div>

</form>

</div>
</div>
</div>    
</div> 
</template>

<script>

import alertBox         from '@/components/common/AlertBox.vue'
import api              from '@/api'
import { mapGetters }    from 'vuex'
export default {
  
  components: {alertBox},  
  props: ['items','mpId'],
 
  data () {
  
    return {
     
        
     discount1   : 0,
     discount2   : 0,
     
     bt_spinner  : false,
     
     msg     : {
       title : '',
       body  : '',
       type  : 0
     },
    

    }
  },
  computed :{
    ...mapGetters(['company'])
  },
  mounted()
    {
      

      $('#MarketPromoModal').on('shown.bs.modal', function () {
        $('#discount1').trigger('focus')
      })
      
    },

  created()
  {
    
  
  },

  methods: 
  {

    submit()
    {
      
      this.saveData()
      //this.$emit('update',this.discount)

    },
    saveData() {
      this.bt_spinner = true
      this.msg.title = ''
      let arr        = []
      
      const sp         = {'sp' : 'spUpdateMarketPromoProduct'}
      this.items.forEach(item => {

        arr.push({'productId':item.productId})
      })

      const data  = {
        'body'        : arr,
        'companyId'   : this.company.Id,
        'mpId'        : this.mpId,
        'discount1'   : this.discount1,
        'discount2'   : this.discount2
      }
      
      const json  = Object.assign(data, sp)      
      console.log(json)
      api.post(json).then(async res => {
         
          if(res.status==200)
            {
              
                          
              this.msg.title = 'PROMO APPLICATA CON SUCCESSO.'
              this.msg.body  = ''
              this.msg.type  = 0
              

              
             

            }
            else if (res.status==500)
            {
              
              
              
              this.msg.title = 'ATTENZIONE '
              this.msg.body  = res.data
              this.msg.type  = 1
              
              
            }
          
          else
          {

            
            this.msg.title = 'ATTENZIONE '
            this.msg.body  = res
            this.msg.type  = 1
                                    

          }
      }).catch(err=>{
        
            
            
            
            this.msg.title = 'ATTENZIONE '
            this.msg.body  = err.message
            this.msg.type  = 1
            
        

      }).finally(() => {
          this.bt_spinner = false
        });
      

    },


    
 
        
}
  
}
</script>

<style scoped>
.modal-content {
  -webkit-border-radius: 0px !important;
  -moz-border-radius: 0px !important;
  border-radius: 15px !important;
  -webkit-border: 0px !important;
  -moz-border: 15px !important;
  border: 0px !important;

}

.pointer{
  cursor: pointer;
}


h4 {
  font-family  : 'Roboto Condensed';
  font-size    : 20px;
  
}



.calc{
  background-color:  #ffc107;;
}
</style>